import React, {useContext, useEffect, useState} from "react";
import $ from "jquery";
import GraphPieIcon from "../../../icons/GraphPieIcon";
import ArraySortIcon from "../../../icons/ArraySortIcon";
import GraphBarIcon from "../../../icons/GraphBarIcon";
import ChartModule from "./ChartModule";
import ProductDetails from "./ProductDetails";
import StringTools from "../../../../class/tool/StringTools";
import StatisticContext from "../../../../context/StatisticContext";

const ChartSheet = () => {
    const { pricelists, subCategories, loading, statsCA, statsSales, statsPayments, statsVats, statsPricelists, statsCategories, statsSubCategories, statsProducts } = useContext(StatisticContext);
    const [ turnover, setTurnover ] = useState(0);
    const [ variationTurnover, setVariationTurnover ] = useState("");
    const [ variationValueTurnover, setVariationValueTurnover ] = useState(0);
    const [ nbSales, setNbSales ] = useState(0);
    const [ variationNbSales, setVariationNbSales ] = useState("");
    const [ variationValueNbSales, setVariationValueNbSales ] = useState(0);
    const [ averagePrice, setAveragePrice ] = useState(0);
    const [ variationAveragePrice, setVariationAveragePrice ] = useState("");
    const [ variationValueAveragePrice, setVariationValueAveragePrice ] = useState(0);
    const [ averageQuantity, setAverageQuantity ] = useState(0);
    const [ variationAverageQuantity, setVariationAverageQuantity ] = useState("");
    const [ variationValueAverageQuantity, setVariationValueAverageQuantity ] = useState(0);
    const [ productDetails, setProductDetails ] = useState(null);
    const subPeriodsModel = {
        sorting:
            window.matchMedia('(max-width: 640px)').matches
            ? [
                { value: "nb", title: "Ventes" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" }
            ]
            : [
                { value: "nb", title: "Ventes" },
                { value: "averagePrice", title: "Panier moyen" },
                { value: "averageQuantity", title: "Article moyen" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" }
            ],
        types: [
            { value: "bar", icon: <GraphBarIcon /> },
            { value: "array", icon: <ArraySortIcon /> }
        ],
        table: [
            {
                name: "Période",
                target: "metadatas",
                type: "text",
                classname: "left",
                object: "name",
                suffix: ""
            },
            {
                name: "Ventes",
                target: "datas",
                type: "int",
                classname: "center",
                object: "nb",
                suffix: ""
            },
            {
                name: "Panier moyen",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "averagePrice",
                suffix: ""
            },
            {
                name: "Articles moyen",
                target: "datas",
                type: "int",
                classname: "center",
                object: "averageQuantity",
                suffix: ""
            },
            {
                name: "HT",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "exclTax",
                suffix: ""
            },
            {
                name: "TTC",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "inclTax",
                suffix: ""
            }
        ],
        selectable: false,
        downloadable: false,
        inTotal: false
    };
    const paymentsModel = {
        sorting:
            window.matchMedia('(max-width: 640px)').matches
            ? [
                { value: "quantity", title: "Qté" },
                { value: "amount", title: "Montant" }
            ]
            : [
                { value: "quantity", title: "Quantité" },
                { value: "amount", title: "Montant" }
            ],
        types: [
            { value: "pie", icon: <GraphPieIcon /> },
            { value: "array", icon: <ArraySortIcon /> }
        ],
        table: [
            {
                name: "Nom",
                target: "metadatas",
                type: "text",
                classname: "left",
                object: "name",
                suffix: "",
                inTotal: "label"
            },
            {
                name: "Quantité",
                target: "datas",
                type: "int",
                classname: "center",
                object: "quantity",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "Montant",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "amount",
                suffix: "",
                inTotal: "value"
            }
        ],
        selectable: false,
        downloadable: false,
        inTotal: true
    };
    const vatsModel = {
        sorting: [
            { value: "amount", title: "Montant" },
            { value: "exclTax", title: "HT" },
            { value: "inclTax", title: "TTC" }
        ],
        types: [
            { value: "pie", icon: <GraphPieIcon /> },
            { value: "array", icon: <ArraySortIcon /> }
        ],
        table: [
            {
                name: "TVA",
                target: "metadatas",
                type: "text",
                classname: "left",
                object: "name",
                suffix: "",
                inTotal: "label"
            },
            {
                name: "Montant",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "amount",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "HT",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "exclTax",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "TTC",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "inclTax",
                suffix: "",
                inTotal: "value"
            }
        ],
        selectable: false,
        downloadable: false,
        inTotal: true
    };
    const pricelistsModel = {
        sorting: [
            { value: "exclTax", title: "HT" },
            { value: "inclTax", title: "TTC" }
        ],
        types: [
            { value: "pie", icon: <GraphPieIcon /> },
            { value: "array", icon: <ArraySortIcon /> }
        ],
        table: [
            {
                name: "Nom",
                target: "metadatas",
                type: "text",
                classname: "left",
                object: "name",
                suffix: "",
                inTotal: "label"
            },
            {
                name: "HT",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "exclTax",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "TTC",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "inclTax",
                suffix: "",
                inTotal: "value"
            }
        ],
        selectable: false,
        downloadable: false,
        inTotal: true
    };
    const categoriesModel = {
        sorting:
            window.matchMedia('(max-width: 640px)').matches
            ? [
                { value: "quantity", title: "Qté" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" }
            ]
            : [
                { value: "quantity", title: "Quantité" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" }
            ],
        types: [
            { value: "pie", icon: <GraphPieIcon /> },
            { value: "array", icon: <ArraySortIcon /> }
        ],
        table: [
            {
                name: "Nom",
                target: "metadatas",
                type: "text",
                classname: "left",
                object: "name",
                suffix: "",
                inTotal: "label"
            },
            {
                name: "Quantité",
                target: "datas",
                type: "int",
                classname: "center",
                object: "quantity",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "HT",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "exclTax",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "TTC",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "inclTax",
                suffix: "",
                inTotal: "value"
            }
        ],
        selectable: true,
        downloadable: false,
        inTotal: true
    };
    const subCategoriesModel = {
        sorting:
            window.matchMedia('(max-width: 640px)').matches
            ? [
                { value: "quantity", title: "Qté" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" }
            ]
            : [
                { value: "quantity", title: "Quantité" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" }
            ],
        types: [
            { value: "pie", icon: <GraphPieIcon /> },
            { value: "array", icon: <ArraySortIcon /> }
        ],
        table: [
            {
                name: "Nom",
                target: "metadatas",
                type: "text",
                classname: "left",
                object: "name",
                suffix: "",
                inTotal: "label"
            },
            {
                name: "Quantité",
                target: "datas",
                type: "int",
                classname: "center",
                object: "quantity",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "HT",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "exclTax",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "TTC",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "inclTax",
                suffix: "",
                inTotal: "value"
            }
        ],
        selectable: true,
        downloadable: false,
        inTotal: true
    };
    const productsModel = {
        sorting:
            window.matchMedia('(max-width: 640px)').matches
            ? [
                { value: "quantity", title: "Qté" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" }
            ]
            : [
                { value: "quantity", title: "Quantité" },
                { value: "exclTax", title: "HT" },
                { value: "inclTax", title: "TTC" }
            ],
        types: [
            { value: "array", icon: <ArraySortIcon /> }
        ],
        table: [
            {
                name: "Nom",
                target: "metadatas",
                type: "text",
                classname: "left",
                object: "name",
                suffix: "",
                inTotal: "label"
            },
            {
                name: "Quantité",
                target: "datas",
                type: "int",
                classname: "center",
                object: "quantity",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "HT",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "exclTax",
                suffix: "",
                inTotal: "value"
            },
            {
                name: "TTC",
                target: "datas",
                type: "decimal",
                classname: "right",
                object: "inclTax",
                suffix: "",
                inTotal: "value"
            }
        ],
        selectable: false,
        downloadable: false,
        inTotal: false,
        limit: 10
    };

    const placeInit = () => {
        const chartSheetOffset = $(".chartSheet").offset();

        $(".chartSheet").css({minHeight: $(document).height() - chartSheetOffset.top - 25});
    }
    const checkLoading = () => {
        const attributes = ["subPeriods", "keys", "payments", "vats", "pricelists", "categories", "subCategories", "products"];

        if (loading.global) {
            for (let i in attributes)
                $("." + attributes[i]).removeClass("loaded");
        }
        else {
            let time = 0;

            for (let i in attributes) {
                setTimeout(function(){
                    $("." + attributes[i]).addClass("loaded");
                }, time);

                time += 150;
            }
        }
    }
    const explodeCA = () => {
        if (statsCA === null) return;

        try {
            setTurnover(StringTools.number_format(statsCA.date.period.datas.inclTax, 2, ",", " "));
            setVariationTurnover(statsCA.delta.period.datas.inclTaxValue > 0 ? "up" : "down");
            setVariationValueTurnover(StringTools.number_format(Math.abs(statsCA.delta.period.datas.inclTaxPercent), 1, ",", " "));
        }
        catch (e) { console.error(e); }
    }
    const explodeSales = () => {
        if (statsCA === null || statsSales === null) return;

        try {
            setNbSales(StringTools.number_format(statsSales.date.period.datas.nb, 0, ",", " "));
            setVariationNbSales(statsSales.delta.period.datas.nbValue > 0 ? "up" : "down");
            setVariationValueNbSales(StringTools.number_format(Math.abs(statsSales.delta.period.datas.nbPercent), 1, ",", " "));
            setAveragePrice(StringTools.number_format(statsSales.date.period.datas.averagePrice, 2, ",", " "));
            setVariationAveragePrice(statsSales.delta.period.datas.averagePriceValue > 0 ? "up" : "down");
            setVariationValueAveragePrice(StringTools.number_format(Math.abs(statsSales.delta.period.datas.averagePricePercent), 1, ",", " "));

            const avgQty = Math.round(parseInt(statsCA.date.period.datas.quantity) / parseInt(statsSales.date.period.datas.nb));
            const avgQtyVersus = Math.round(parseInt(statsCA.versus.period.datas.quantity) / parseInt(statsSales.versus.period.datas.nb));
            const avgQtyPercent = 100 - (avgQtyVersus * 100) / avgQty;

            setAverageQuantity(StringTools.number_format(avgQty, 0, ",", " "));
            setVariationAverageQuantity((avgQty - avgQtyVersus) > 0 ? "up" : "down");
            setVariationValueAverageQuantity(StringTools.number_format(Math.abs(avgQtyPercent), 1, ",", " "));
        }
        catch (e) { console.error(e); }
    }
    const buildLastParts = () => {
        if (pricelists === null) return;

        if (pricelists.total > 1 && subCategories !== null) {
            return <>
                <div className={"part fiftyFifty"}>
                    <ChartModule id={"pricelists"} classname={"pricelists"} title={"Tarifs"} stats={statsPricelists} model={pricelistsModel} />
                    <ChartModule id={"categories"} classname={"categories right"} title={"Catégories"} stats={statsCategories} model={categoriesModel} clickOn={clickOnCategory} />
                </div>
                <div className={"part fiftyFifty"}>
                    <ChartModule id={"subCategories"} classname={"subCategories"} title={"Sous-catégories"} stats={statsSubCategories} model={subCategoriesModel} clickOn={clickOnSubCategory} />
                    <ChartModule id={"products"} classname={"products right"} title={"Produits - Top 10"} stats={statsProducts} model={productsModel} />
                </div>
            </>;
        }
        else if (pricelists.total > 1 && subCategories === null) {
            return <>
                <div className={"part fiftyFifty"}>
                    <ChartModule id={"pricelists"} classname={"pricelists"} title={"Tarifs"} stats={statsPricelists} model={pricelistsModel} />
                    <ChartModule id={"categories"} classname={"categories right"} title={"Catégories"} stats={statsCategories} model={categoriesModel} clickOn={clickOnCategory} />
                </div>
                <div className={"part"}>
                    <ChartModule id={"products"} classname={"products alone"} title={"Produits - Top 10"} stats={statsProducts} model={productsModel} />
                </div>
            </>;
        }
        else if (pricelists.total === 1 && subCategories !== null) {
            return <>
                <div className={"part fiftyFifty"}>
                    <ChartModule id={"categories"} classname={"categories"} title={"Catégories"} stats={statsCategories} model={categoriesModel} clickOn={clickOnCategory} />
                    <ChartModule id={"subCategories"} classname={"subCategories right"} title={"Sous-catégories"} stats={statsSubCategories} model={subCategoriesModel} clickOn={clickOnSubCategory} />
                </div>
                <div className={"part"}>
                    <ChartModule id={"products"} classname={"products alone"} title={"Produits - Top 10"} stats={statsProducts} model={productsModel} />
                </div>
            </>;
        }
        else {
            return <div className={"part fiftyFifty"}>
                <ChartModule id={"categories"} classname={"categories"} title={"Catégories"} stats={statsCategories} model={categoriesModel} clickOn={clickOnCategory} />
                <ChartModule id={"products"} classname={"products right"} title={"Produits - Top 10"} stats={statsProducts} model={productsModel} />
            </div>;
        }
    }
    const clickOnCategory = category => {
        setProductDetails({
            type: "category",
            datas: category.metadatas
        });
    }
    const clickOnSubCategory = subCategory => {
        setProductDetails({
            type: "subCategory",
            datas: subCategory.metadatas
        });
    }
    const closeProductDetails = () => {
        setProductDetails(null);
    }

    useEffect(() => {
        placeInit();
    }, []);
    useEffect(() => {
        checkLoading();
    }, [loading]);
    useEffect(() => {
        explodeCA();
    }, [statsCA]);
    useEffect(() => {
        explodeSales();
    }, [statsCA, statsSales]);

    return(
        <div className={"chartSheet"}>
            <ProductDetails parent={productDetails} close={closeProductDetails} />
            <div className={"part seventyFive"}>
                {
                    /*<ChartModule id={"subPeriods"} classname={"subPeriods"} title={"Périodes"} stats={{statsCA, statsSales}} model={subPeriodsModel} />*/
                }
                <div className={"keys"}>
                    <div className={"key"}>
                        <p className={"title"}>Chiffre d'affaires</p>
                        <div className={"values marginBottom"}>
                            <p className={"value"}>{turnover}</p>
                            <div className={"variation " + variationTurnover} />
                            <p className={"valueVariation " + variationTurnover}>{variationValueTurnover} %</p>
                        </div>
                    </div>
                    <div className={"key"}>
                        <p className={"title"}>Ventes</p>
                        <div className={"values marginBottom"}>
                            <p className={"value"}>{nbSales}</p>
                            <div className={"variation " + variationNbSales} />
                            <p className={"valueVariation " + variationNbSales}>{variationValueNbSales} %</p>
                        </div>
                    </div>
                    <div className={"key"}>
                        <p className={"title"}>Panier moyen</p>
                        <div className={"values"}>
                            <p className={"value"}>{averagePrice}</p>
                            <div className={"variation " + variationAveragePrice} />
                            <p className={"valueVariation " + variationAveragePrice}>{variationValueAveragePrice} %</p>
                        </div>
                    </div>
                    <div className={"key"}>
                        <p className={"title"}>Nb articles moyen</p>
                        <div className={"values"}>
                            <p className={"value"}>{averageQuantity}</p>
                            <div className={"variation " + variationAverageQuantity} />
                            <p className={"valueVariation " + variationAverageQuantity}>{variationValueAverageQuantity} %</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"part fiftyFifty"}>
                <ChartModule id={"payments"} classname={"payments"} title={"Règlements"} stats={statsPayments} model={paymentsModel} />
                <ChartModule id={"vats"} classname={"vats"} title={"TVA"} stats={statsVats} model={vatsModel} />
            </div>
            { buildLastParts() }
        </div>
    );
}

export default ChartSheet;
